// extracted by mini-css-extract-plugin
export default {"animationContainer":"lottieAnimation_animationContainer__U4JE1","show":"lottieAnimation_show__o961E","animation":"lottieAnimation_animation__FVPxV"};